import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { CurrencyInput } from 'ui-components/components/currency-input';

import style from '../edit-amount-summary-modal.module.less';

const EditableCurrencyColumn = ({ currencyValue, updateRowProperty, original, columnId }) => {
  const onBlur = useCallback(
    (newValue) => {
      updateRowProperty(original, columnId, newValue);
    },
    [original, updateRowProperty, columnId],
  );
  return (
    <div className={style.input}>
      <CurrencyInput
        currencyCode={currencyValue.code}
        currencySymbolClassName={style['currency-symbol']}
        disabled={currencyValue.disabled}
        onBlur={onBlur}
        showPlaceHolderForZero
        value={currencyValue.value}
      />
    </div>
  );
};

EditableCurrencyColumn.propTypes = {
  currencyValue: PropTypes.shape({
    code: PropTypes.string,
    value: PropTypes.number,
    disabled: PropTypes.bool,
  }).isRequired,
  updateRowProperty: PropTypes.func.isRequired,
  columnId: PropTypes.string.isRequired,
  original: PropTypes.object.isRequired,
};

export { EditableCurrencyColumn };
